import * as React from 'react'
import { Grid, Col, Row } from 'react-bootstrap';
import { ViolationsHistory } from "../../components/ViolationsHistory"
import { ViolationsHistoryList } from "../../components/ViolationsHistoryList"
import { ViolationsHistoryDetails} from "../../components/ViolationsHistoryDetails"
import { ViolationsPagination } from "../../components/ViolationsPagination"
import "./ViolationsHistory.css";


export const ViolationsHistoryInner = (props: any) =>
    <div>
        <Grid bsClass="container">
            <Row>
                <Col xs={12} md={12}>
                    <ViolationsHistory/>
                </Col>
            </Row>
            <Row>
                <Col id = "violationDetailsList" xs={12} md={6}>
                    <ViolationsHistoryList/>
                    <ViolationsPagination />

                   
                </Col>
                <Col id = "violationImageDetails" xs={12} md={6}>
                    <ViolationsHistoryDetails/>
                </Col>   
            </Row>
        </Grid>
    </div>


// WEBPACK FOOTER //
// ./src/Routes/ViolationsHistory/ViolationsHistoryInner.tsx